export default __webpack_public_path__ + "static/media/Ballroll_00219.dc3e1a12.png";